"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPage = exports.initPage = exports.setCustomData = exports.setPageLabel = exports.setSampleRate = exports.setMeasure = exports.setMark = void 0;

var _featureDetection = require("js-utils/feature-detection");

/**
 * Set a performance mark with the given name
 * @param  {string} markName Mark name
 * @return {void}
 */
var setMark = function setMark(markName) {
  if (!markName) {
    throw new Error('Missing mark name');
  }

  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX && LUX.mark) {
    LUX.mark(markName);
  }
};
/**
 * Measure a delta between two different performance marks
 * @param  {string} measureName Measure name
 * @param  {string} startMark   Initial mark name
 * @param  {string} endMark     End mark name
 * @return {void}
 */


exports.setMark = setMark;

var setMeasure = function setMeasure(measureName, startMark, endMark) {
  if (!measureName || !startMark || !endMark) {
    throw new Error('Missing parameters');
  }

  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX && LUX.measure) {
    LUX.measure(measureName, startMark, endMark);
  }
};
/**
 * Set the sample rate in percentage (0-100).
 * Use this function to set different sample rates for different pages, devices or countries.
 * @param  {number} samplePercentage     New sample rate
 * @return {void}
 */


exports.setMeasure = setMeasure;

var setSampleRate = function setSampleRate(samplePercentage) {
  if (typeof samplePercentage !== 'number') {
    throw new Error('Missing sample rate number');
  }

  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX) {
    LUX.samplerate = samplePercentage;
  }
};
/**
 * Sets the page label to the current page. By default it uses the `window.title` value.
 * @param  {string} pageLabel   Label for the current page
 * @return {void}
 */


exports.setSampleRate = setSampleRate;

var setPageLabel = function setPageLabel(pageLabel) {
  if (!pageLabel) {
    throw new Error('Missing page label');
  }

  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX) {
    LUX.label = pageLabel;
  }
};
/**
 * Add your data to the analytics information.
 * It allows to send a set of key and value pair that will show up in our dashboards.
 * @param  {string} key                 Key for the custom data
 * @param  {string | number} value      Value for the custom data
 * @return {void}
 */


exports.setPageLabel = setPageLabel;

var setCustomData = function setCustomData(key, value) {
  if (!key || !value) {
    throw new Error('Missing parameters');
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    throw new Error('Wrong value type');
  }

  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX && LUX.addData) {
    LUX.addData(key, value);
  }
};
/**
 * Marks the beginning of the page transition.
 * If the user clicked a button that causes a SPA transition, you would call `.initPage()``
 * immediately after the button is clicked.
 * @return {void}
 */


exports.setCustomData = setCustomData;

var initPage = function initPage() {
  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX && LUX.init) {
    LUX.init();
  }
};
/**
 * Marks the end of the transition.
 * Call this function at the end of the SPA page transition.
 * For example, you would call `.sendPage()`
 * after all JSON responses have been received and the DOM has been updated.
 * @return {void}
 */


exports.initPage = initPage;

var sendPage = function sendPage() {
  var LUX = (0, _featureDetection.getWindowObject)('LUX');

  if (LUX && LUX.send) {
    LUX.send();
  }
};

exports.sendPage = sendPage;
//# sourceMappingURL=index.js.map